import { Anchor, Button, Flex, Text } from '@mantine/core';
import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';

interface Props {
	onAdd?: () => void;
}

export const EmptyDashboard = ({ onAdd }: Props) => {
	const tAdminDashboard = useTranslationAdminDashboard();

	return (
		<EmptyState
			iconSize="lg"
			title={tAdminDashboard('v3.no_data.no_deal_added')}
			description={tAdminDashboard('v3.no_data.add_first_deal')}
		>
			<Flex direction="column" align="center" gap="1rem">
				<Button leftSection={<Icon variant="add" size="lg" />} onClick={onAdd}>
					{tAdminDashboard('v3.no_data.add_new_deal')}
				</Button>
				<Text c="neutral.7" size="B6Medium">
					{tAdminDashboard('v3.no_data.need_help')}
				</Text>
				<Anchor href={`mailto:${tAdminDashboard('v3.no_data.support_mail')}`} target="_top">
					<Text c="blue" size="B6Bold">
						{tAdminDashboard('v3.no_data.contact_support')}
					</Text>
				</Anchor>
			</Flex>
		</EmptyState>
	);
};
